import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    searchFilterSources: {
      filterOutputCategory: {}, // 搜索结果 output categories
      filterOutputManufacturer: {}, // 搜索结果 output manufacturers
      filterOutputSpecifications: [], // 搜索结果 output specifications
      filterOutputAttributes: [] // 搜索结果 output attributes
    },
    searchProductList: [], // 搜索商品结果
    addressList: [],
    invoiceAddressList: [],
    isLoading: false, // 是否展示loading动画
    isLogged: false,
    loginUserInfo: { // 登录用户信息
      AuthToken: '',
      NickName: '',
      AvatarUrl: '',
      UserLevel: ''
    },
    skfSSO: {
      openUrl: 'https://admin.sso.demo.aks.chilunyc.com/'
    },
    currentArea: {
      province: '北京',
      city: '北京'
    },
    shoppingCart: [] // 购物车
  },
  getters,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js